import { invalidateCachedValue } from "./localDataCache";

export const FRIEND_ROSTER_CACHE_TTL = 4 * 60 * 60 * 1000;
export const FRIEND_ROSTER_STALE_TTL = 30 * 24 * 60 * 60 * 1000;

export const getFriendRosterCacheKey = (userId?: string) =>
  `friend_roster_v2_${String(userId || "")}`;

export const getFriendCountCacheKey = (userId?: string) =>
  `friend_roster_count_v1_${String(userId || "")}`;

export const FRIEND_ROSTER_CACHE_OPTIONS = Object.freeze({
  ttl: FRIEND_ROSTER_CACHE_TTL,
  staleTtl: FRIEND_ROSTER_STALE_TTL,
  staleWhileRevalidate: true
});

export const invalidateFriendRosterCache = (userId: string|null|undefined) => {
  if (!userId) return Promise.resolve();
  return Promise.all([
    invalidateCachedValue(getFriendRosterCacheKey(userId)),
    invalidateCachedValue(getFriendCountCacheKey(userId))
  ]);
};
